module.exports = __webpack_public_path__ + "assets/img/left_column_illustration.bc82daa6.svg";